<template>
    <b-form-group :label="label" label-for="description">
        <quill-editor
            id="description"
            :value="value"
            :state="state"
            @input="$emit('update:value', $event)"
            :options="editorOption"
            :disabled="disabled"
            @change="$emit('save-comment', $event)"
        />
    </b-form-group>
</template>

<script>
export default {
    name: 'Description',
    data() {
        return {
            editorOption: {
                placeholder: this.placeholder,
                modules: {
                    toolbar: [
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                        { color: [] },
                        { list: 'ordered' },
                        { list: 'bullet' },
                        { header: [1, 2, 3, 4, false] },
                        { header: 1 },
                        { header: 2 },
                    ],
                },
            },
        }
    },
    methods: {},
    props: ['value', 'state', 'disabled', 'label', 'placeholder'],
}
</script>

<style>
.ql-snow {
    border-color: #e4e7ea !important;
}

.ql-editor {
    min-height: 150px;
}
</style>
